import { NgTemplateOutlet } from '@angular/common';
import { Component, HostBinding, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-icon-button',
  templateUrl: './icon-button.component.html',
  styleUrls: ['./icon-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatIconModule, NgTemplateOutlet],
})
export class IconButtonComponent {
  @HostBinding('tabindex') tabindex = -1;
  @Input() tabIndex: number;
  @Input() skipTab = false;
  @Input() disabled = false;
  @Input() smallIcon = false;
  @Input() icon: string;
  @Input() border = true;
  @Input() href: string;
  @Input() type: 'button' | 'menu' | 'reset' | 'submit' = 'submit';
}
